import React from "react";
import GoogleMapReact from 'google-map-react';
import MarcadorDeZonaComponent from "./MarcadorDeZonaComponent";
import MarcadorDeAsociadoComponent from "./MarcadorDeAsociadoComponent";
import { K_SIZE } from './EstilosHoverMap.js';

import { Fragment } from 'react';


export default function MapaComponent(props) {

  const tipo = props.tipo
  const asociados = props.asociados
  const localidades = props.localidades

  const [mostrarVentanita, setMostrarVentanita] = React.useState(false);

  const handleMostrarVentanita = () => {
    setMostrarVentanita(true);
  }

  const handleCerrarVentanita = () => {
    setMostrarVentanita(false);

  }

  const defaultProps = {
    centro: {
      lat: parseInt(props.lat),
      lng: parseInt(props.lng)
    },
    zoom: props.zoom
  };
  const handleApiLoaded = (map, maps) => {
    // use map and maps objects
  };

  return (
    <Fragment>
      {
        tipo === 1 ? (
          <div style={{ height: '100vh', width: '100%' }}>
            <GoogleMapReact
              bootstrapURLKeys={{ key: "AIzaSyAcjbOJJFtJYTp5K2YYxzrghuztGXhWnOw" }}
              defaultCenter={defaultProps.centro}
              defaultZoom={defaultProps.zoom}
              yesIWantToUseGoogleMapApiInternals
              onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
            >
              {
                localidades.map((localidad, index) => {
                  return (
                    <MarcadorDeZonaComponent key={index} localidad={localidad} color={'red'} name={localidad.nombrelocalidad} text={localidad.nombrelocalidad} lng={localidad.longitud} lat={localidad.latitud}></MarcadorDeZonaComponent>

                  )
                }
                )
              }
            </GoogleMapReact>
          </div>
        ) :
          tipo === 2 ? (
            <div style={{ height: '100vh', width: '100%' }}>
              <GoogleMapReact
                bootstrapURLKeys={{ key: "AIzaSyAcjbOJJFtJYTp5K2YYxzrghuztGXhWnOw" }}
                defaultCenter={defaultProps.centro}
                defaultZoom={defaultProps.zoom}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
              >
                {
                  asociados.map((asociado, index) => (
                    <MarcadorDeAsociadoComponent key={index} asociado={asociado} lng={asociado.lng} lat={asociado.lat}></MarcadorDeAsociadoComponent>
                  ))
                }
              </GoogleMapReact>
            </div>
          ) :
            (<></>)
      }
    </Fragment>
  );
}